import { he } from "date-fns/locale";
import axiosInstance from "./axiosConfig";
import { jwtDecode } from 'jwt-decode'; // Você precisará instalar esta biblioteca: npm install jwt-decode

class AuthService {
  constructor() {
    this.tokenKey = 'auth_token';
    this.expiresAtKey = 'token_expires_at';
    this.userKey = 'current_user';
  }

  async login(email, password) {
    try {
      const response = await axiosInstance.post("login", { email, password });
      console.log("response login", response);
      this.setToken(response.data.accessToken);
      this.setTokenExpirationTime(response.data.expiresIn);
      await this.fetchAndStoreUserData();
      return response.data.accessToken;
    } catch (error) {
      console.error("Erro no login:", error.response?.data || error.message);
      throw error;
    }
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.expiresAtKey);
    localStorage.removeItem(this.userKey);
  }

  setToken(token) {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken() {
    return localStorage.getItem(this.tokenKey);
  }

  setTokenExpirationTime(expiresIn) {
    const expiresAt = new Date().getTime() + expiresIn * 1000;
    localStorage.setItem(this.expiresAtKey, expiresAt.toString());
  }

  isTokenExpired() {
    const expiresAt = localStorage.getItem(this.expiresAtKey);
    return !expiresAt || new Date().getTime() > parseInt(expiresAt);
  }

  async isAuthenticated() {

    const token = this.getToken();

    if (!token) {
      return false;
    }

    if (!this.isTokenExpired()) {
      return true;
    }

    try {

      await this.refreshToken();
      return true;

    } catch {

      this.logout();
      return false;

    }
  }

  async refreshToken() {
    try {
      const response = await axiosInstance.post("refresh-token");

      this.setToken(response.data.accessToken);
      this.setTokenExpirationTime(response.data.expiresIn);

      await this.fetchAndStoreUserData();
      
      return response.data.accessToken;
    } catch (error) {
      console.error("Erro ao atualizar o token:", error.response?.data || error.message);
      this.logout();
      throw error;
    }
  }

  async fetchAndStoreUserData() {
    try {
      const response = await axiosInstance.get("users/profile", { headers: { 'Authorization': `Bearer ${this.getToken()}` } });
      // const response = await axiosInstance.get("users/profile");

      localStorage.setItem(this.userKey, JSON.stringify(response.data.data[0]));
    } catch (error) {
      console.error("Erro ao buscar dados do usuário:", error.response?.data || error.message);
    }
  }

  getCurrentUser() {
    const userStr = localStorage.getItem(this.userKey);
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (error) {
        console.error("Erro ao analisar dados do usuário:", error);
        return null;
      }
    }
    return null;
  }

  getUserIdFromToken() {
    const token = this.getToken();
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        return decodedToken.sub; // Assumindo que o ID do usuário está no campo 'sub' do token
      } catch (error) {
        console.error("Erro ao decodificar o token:", error);
        return null;
      }
    }
    return null;
  }
}

export default new AuthService();